import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import HideAppBar from './HideAppBar';
import ClientProvider from './client';
export default createDemo(import.meta.url, HideAppBar, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/app-bar/demos/hide/HideAppBar.tsx",
    "fileName": "HideAppBar.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport AppBar from '@mui/material/AppBar';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport CssBaseline from '@mui/material/CssBaseline';\nimport useScrollTrigger from '@mui/material/useScrollTrigger';\nimport Box from '@mui/material/Box';\nimport Container from '@mui/material/Container';\nimport Slide from '@mui/material/Slide';\n\ninterface Props {\n  /**\n   * Injected by the documentation to work in an iframe.\n   * You won't need it on your project.\n   */\n  window?: () => Window;\n  children?: React.ReactElement<unknown>;\n}\n\nfunction HideOnScroll(props: Props) {\n  const { children, window } = props;\n  // Note that you normally won't need to set the window ref as useScrollTrigger\n  // will default to window.\n  // This is only being set here because the demo is in an iframe.\n  const trigger = useScrollTrigger({\n    target: window ? window() : undefined,\n  });\n\n  return (\n    <Slide appear={false} direction=\"down\" in={!trigger}>\n      {children ?? <div />}\n    </Slide>\n  );\n}\n\nexport default function HideAppBar(props: Props) {\n  return (\n    <React.Fragment>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <CssBaseline />\n      <HideOnScroll {...props}>\n        <AppBar>\n          <Toolbar>\n            <Typography variant=\"h6\" component=\"div\">\n              Scroll to hide App bar\n            </Typography>\n          </Toolbar>\n        </AppBar>\n      </HideOnScroll>\n      <Toolbar />\n      <Container>\n        <Box sx={{ my: 2 }}>\n          {[...new Array(12)]\n            .map(\n              () => `Cras mattis consectetur purus sit amet fermentum.\nCras justo odio, dapibus ac facilisis in, egestas eget quam.\nMorbi leo risus, porta ac consectetur ac, vestibulum at eros.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et.`,\n            )\n            .join('\\n')}\n        </Box>\n      </Container>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </React.Fragment>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 64,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport AppBar from '@mui/material/AppBar';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport CssBaseline from '@mui/material/CssBaseline';\nimport useScrollTrigger from '@mui/material/useScrollTrigger';\nimport Box from '@mui/material/Box';\nimport Container from '@mui/material/Container';\nimport Slide from '@mui/material/Slide';\n\ninterface Props {\n  /**\n   * Injected by the documentation to work in an iframe.\n   * You won't need it on your project.\n   */\n  window?: () => Window;\n  children?: React.ReactElement<unknown>;\n}\n\nfunction HideOnScroll(props: Props) {\n  const { children, window } = props;\n  // Note that you normally won't need to set the window ref as useScrollTrigger\n  // will default to window.\n  // This is only being set here because the demo is in an iframe.\n  const trigger = useScrollTrigger({\n    target: window ? window() : undefined,\n  });\n\n  return (\n    <Slide appear={false} direction=\"down\" in={!trigger}>\n      {children ?? <div />}\n    </Slide>\n  );\n}\n\nexport default function HideAppBar(props: Props) {\n  return (\n    <React.Fragment>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "      <CssBaseline />\n      <HideOnScroll {...props}>\n        <AppBar>\n          <Toolbar>\n            <Typography variant=\"h6\" component=\"div\">\n              Scroll to hide App bar\n            </Typography>\n          </Toolbar>\n        </AppBar>\n      </HideOnScroll>\n      <Toolbar />\n      <Container>\n        <Box sx={{ my: 2 }}>\n          {[...new Array(12)]\n            .map(\n              () => `Cras mattis consectetur purus sit amet fermentum.\nCras justo odio, dapibus ac facilisis in, egestas eget quam.\nMorbi leo risus, porta ac consectetur ac, vestibulum at eros.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et.`,\n            )\n            .join('\\n')}\n        </Box>\n      </Container>\n"
      ],
      [
        "span",
        "frame",
        "    </React.Fragment>\n  );\n}\n"
      ]
    ],
    "totalLines": 64,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/AppBar",
      "@mui/material/Toolbar",
      "@mui/material/Typography",
      "@mui/material/CssBaseline",
      "@mui/material/useScrollTrigger",
      "@mui/material/Box",
      "@mui/material/Container",
      "@mui/material/Slide"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
